import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import Callback from '@/components/Callback';
import AlertsReport from '@/components/AlertsReport';
import Help from '@/components/Help';
import LatestPosts from '@/components/LatestPosts';
import IQFirmware from '@/components/IQFirmware';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '/alertsreport',
      name: 'AlertsReport',
      component: AlertsReport
    },
    {
      path: '/latestposts',
      name: 'LatestPosts',
      component: LatestPosts
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/firmware',
      name: 'IQFirmware',
      component: IQFirmware
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js